import { render, staticRenderFns } from "./TryItOut.vue?vue&type=template&id=36e8bd3b&lang=pug&"
import script from "./TryItOut.vue?vue&type=script&lang=js&"
export * from "./TryItOut.vue?vue&type=script&lang=js&"
import style0 from "./TryItOut.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports